import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import DiscoveryGrid from '../DiscoveryGrid/DiscoveryGrid';
import {
    useIsCalibrationDataChartPaneVisible,
    useIsChartPaneVisible,
    useIsDataGridPaneVisible,
    useIsDetectionChartPaneVisible,
    usePane,
} from '../../selectors/index.hooks';
import { Panel, PanelGroup } from 'react-resizable-panels';
import MapPane from '../../MapPane';
import CustomResizeHandle from '@/app/components/CustomResizeHandle';
import ChartPane from '../ChartPane';
import CalibrationPane from '../CalibrationPane';
import DetectionPane from '../DetectionPane';

const RIGHT_PANE_OFFSET = 'calc(100% - 425px)';

export const FullscreenGrid = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
            }}
        >
            <DiscoveryGrid />
        </Box>
    );
};

export const ResizableGridAndMap = () => {
    const pane = usePane();
    const isDataGridPaneVisible = useIsDataGridPaneVisible();
    const mapPanelRef = useRef<any>(null);
    const gridPanelRef = useRef<any>(null);
    useEffect(() => {
        if (mapPanelRef.current && gridPanelRef.current) {
            if (isDataGridPaneVisible) {
                mapPanelRef.current.resize(40);
                gridPanelRef.current.resize(60);
            } else {
                mapPanelRef.current.resize(100);
            }
        }
    }, [isDataGridPaneVisible]);
    return (
        <Box
            sx={{
                width: pane ? RIGHT_PANE_OFFSET : '100%',
                height: '100%',
            }}
        >
            <PanelGroup direction="vertical" autoSaveId="monitoring">
                <Panel ref={mapPanelRef} defaultSize={40} minSize={15}>
                    <Box
                        sx={{
                            height: '100%',
                            width: '100%',
                            overflow: 'hidden',
                        }}
                    >
                        <MapPane isMobile={false} />
                    </Box>
                </Panel>

                {isDataGridPaneVisible && (
                    <CustomResizeHandle direction="vertical" />
                )}

                <Panel ref={gridPanelRef} defaultSize={60} minSize={0}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            width: '100%',
                            overflow: 'hidden',
                        }}
                    >
                        <DiscoveryGrid />
                    </Box>
                </Panel>
            </PanelGroup>
        </Box>
    );
};

export const FixedGridAndmap = () => {
    const pane = usePane();
    const isChartPaneVisible = useIsChartPaneVisible();
    const isDetectionChartPaneVisible = useIsDetectionChartPaneVisible();
    const isCalibrationChartPaneVisible =
        useIsCalibrationDataChartPaneVisible();

    return (
        <>
            <Box
                sx={{
                    width: pane ? RIGHT_PANE_OFFSET : '100%',
                    height: '100%',
                }}
            >
                <Box
                    sx={{
                        height: '50%',
                    }}
                >
                    <MapPane isMobile={false} />
                </Box>
                <Box
                    sx={{
                        height: '50%',
                    }}
                >
                    {isChartPaneVisible && <ChartPane />}
                    {isCalibrationChartPaneVisible && <CalibrationPane />}
                    {isDetectionChartPaneVisible && <DetectionPane />}
                </Box>
            </Box>
        </>
    );
};
